import { Button, Dropdown } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { PublishedProjectMutableGuard } from '@/features/authentication/_components/PublishedProjectMutableGuard';
import { useProject } from '@/features/project/_hooks/project';
import { useConsecutiveFiscalYears } from '@/features/project/projects/detail/activities/_hooks/consecutive';
import { useId } from '@/hooks';
import { DownOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectDetailDrawerState } from '../../../_components/ProjectDrawerStateProvider';

export const SsDetailedBreakdownDropdownButton: FC = () => {
  const { t } = useTranslation();
  const { setDrawerState } = useProjectDetailDrawerState();
  const { id: projectId } = useId();
  const project = useProject(projectId);
  const consecutiveFiscalYears = useConsecutiveFiscalYears({ id: projectId });

  const showPreviousFiscalYearExecuted = consecutiveFiscalYears.data?.some(
    (year) => year.fiscalYear === (project.data?.fiscalYear ?? 0) - 1,
  );

  return (
    <ProjectResourceGuard onlyEdit>
      <PublishedProjectMutableGuard>
        {!project.data?.isLocked && (
          <Dropdown
            menu={{
              items: [
                ...(showPreviousFiscalYearExecuted
                  ? [
                      {
                        key: '1',
                        label: t('previous-fiscal-year-executed'),
                      },
                    ]
                  : []),
                {
                  key: '2',
                  label: t('current-finalized-amount'),
                },
              ],
              onClick: (e) => {
                switch (e.key) {
                  case '1':
                    setDrawerState({
                      open: true,
                      type: 'ss-previous-fiscal-year-executed',
                    });
                    break;
                  case '2':
                    setDrawerState({
                      open: true,
                      type: 'ss-current-finalized-amount',
                    });
                    break;
                  default:
                }
              },
            }}
          >
            <Button type="primary">
              {t('edit')}
              <DownOutlined />
            </Button>
          </Dropdown>
        )}
      </PublishedProjectMutableGuard>
    </ProjectResourceGuard>
  );
};
